import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { SyllabusQuery } from '@examdojo/category/v2';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { FeatureFlagService } from '@examdojo/core/feature-flag';
import { EMPTY, pairwise, startWith, switchMap, tap } from 'rxjs';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { RootUrlParts } from '../../../app.model';
import { StudentClassAssignmentService } from '../student-class-assignment/student-class-assignment.service';
import { StudentClassService } from '../student-class/student-class.service';
import { StudentClassStore } from '../student-class/student-class.store';

@Injectable()
export class FetchStudentClassesOnSyllabusChangeEffectService {
  constructor(
    private readonly studentClassService: StudentClassService,
    private readonly studentClassAssignmentService: StudentClassAssignmentService,
    private readonly studentClassStore: StudentClassStore,
    private readonly syllabusQuery: SyllabusQuery,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly router: Router,
    private readonly featureFlagService: FeatureFlagService<ExamdojoFeatureFlags>,
  ) {
    if (this.featureFlagService.get(ExamDojoFeatureFlag.Classes)) {
      this.fetchStudentClassesOnSyllabusChange().pipe(takeUntilDestroyed()).subscribe();
    }
  }

  private fetchStudentClassesOnSyllabusChange() {
    return this.syllabusQuery.activeIdAndCourseLevel$.pipe(
      startWith(null),
      pairwise(),
      tap(([prev]) => {
        this.studentClassService.resetStore();

        if (prev && this.isOnClassDetailPage()) {
          this.router.navigate([RootUrlParts.Classes]);
        }
      }),
      switchMap(([, curr]) =>
        this.studentClassService.fetchClasses(curr!.syllabusId, curr!.courseLevel).pipe(
          tap(() => this.studentClassStore.updateProp('initialized', true)),
          this.errorHandlerService.catchHttpErrors(() => EMPTY),
        ),
      ),
    );
  }

  private isOnClassDetailPage(): boolean {
    return this.router.url.startsWith(`/${RootUrlParts.Classes}/`);
  }
}
